import { Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import globalStyle from "../theme/globalStyle";
import { formatWalletAddress } from "../utils/common";
import { useHookstate } from "@hookstate/core";
import { metaMaskState } from "../hooks/store";
import { useState } from "react";
import theme from "../theme/Theme";
import Cookies from "js-cookie";
import { useDisconnect } from "@reown/appkit/react";
import { useNavigate } from "react-router-dom";

import CustomButton from "./CustomButton";

const WalletConnectComponent = ({ title = "Default Title", onClick = () => { } }) => {
    const storeWalletState = useHookstate(metaMaskState);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { disconnect } = useDisconnect();
    const navigate = useNavigate();

    const handleDisconnect = async () => {
        setAnchorEl(null);
        storeWalletState.set({
            isConnected: false,
            address: null,
            walletIcon: null,
            walletName: null,
        });
        Cookies.set("connectedAddress", null);
        localStorage.setItem("connectedWalletInfo", null);
        await disconnect();
        navigate("/");

    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <Stack direction={"row"} alignItems={"center"}>
            <Button
                id="address-button"
                aria-controls={open ? "address-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                sx={globalStyle.walletContainer}
                onClick={handleClick}
            >
                <img
                    src={storeWalletState.get()?.walletIcon}
                    alt={storeWalletState.get()?.walletName}
                    width="22"
                />
                <Typography sx={globalStyle.smallText}>
                    {formatWalletAddress(storeWalletState.get().address)}
                </Typography>
            </Button>
            <Menu
                id="address-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{ "aria-labelledby": "address-button" }}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.custom.white,
                        boxShadow: "rgba(0, 0, 0, 0.2) 2px 2px 2px 0px",
                        borderRadius: "8px",
                    },
                }}
            >
                <MenuItem
                    onClick={handleDisconnect}
                    sx={{
                        fontWeight: 500,
                        fontSize: "1rem",
                        color: theme.palette.primary.main,
                    }}
                >
                    Disconnect
                </MenuItem>
            </Menu>
            <CustomButton title={title} onClick={onClick} />
        </Stack>
    );
};

export default WalletConnectComponent;
